module.exports = __webpack_public_path__ + "img/icono crc.d09757eb.png";